import moment from 'moment'

export const sessionAssignmentsAreAvailable = sessionSale => {
  return moment().isBefore(sessionSale.pre_registration_end_at)
}
